import { render, staticRenderFns } from "./DynamicDomainNameList.vue?vue&type=template&id=7d076942&"
import script from "./DynamicDomainNameList.vue?vue&type=script&lang=js&"
export * from "./DynamicDomainNameList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports